import { ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";
import { Switch } from "@/components/ui/switch";

const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-");

const Row = ({ label, count, active, onClick, testId, indent }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`w-full flex items-center gap-2 rounded-md px-3 py-1.5 text-left text-sm transition-colors ${indent ? "pl-8" : ""} ${active ? "bg-[#C2410C] text-white" : count ? "text-stone-800 hover:bg-stone-100" : "text-stone-400 hover:bg-stone-50"}`}>
    <span className="truncate min-w-0 flex-1">{label}</span>
    <span className={`shrink-0 text-xs ${active ? "text-white" : "text-stone-500"}`}>{count}</span>
  </button>
);

const Category = ({ cat, sel, onSelect, hideEmpty }) => {
  const [open, setOpen] = useState(cat.count > 0 && cat.name !== "Autres / non classés");
  const subs = hideEmpty ? cat.subs.filter((s) => s.count) : cat.subs;
  return (
    <div>
      <div className="flex items-center">
        <button type="button" onClick={() => setOpen(!open)} className="p-1 text-stone-400" data-testid={`cat-toggle-${slug(cat.name)}`} aria-label="Déplier">
          {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
        </button>
        <div className="flex-1"><Row label={cat.name} count={cat.count} active={sel.cat === cat.name && !sel.sub} onClick={() => onSelect({ cat: cat.name })} testId={`cat-${slug(cat.name)}`} /></div>
      </div>
      {open && subs.map((s) => (
        <Row key={s.name} indent label={s.name} count={s.count} active={sel.sub === s.name} onClick={() => onSelect({ cat: cat.name, sub: s.name })} testId={`subcat-${slug(s.name)}`} />
      ))}
    </div>
  );
};

export const SpecialtyTree = ({ tree, sel, onSelect }) => {
  const [hideEmpty, setHideEmpty] = useState(false);
  const total = tree.reduce((a, c) => a + c.count, 0);
  const cats = hideEmpty ? tree.filter((c) => c.count) : tree;
  return (
    <aside className="bg-white border border-stone-200 rounded-lg p-3 space-y-1 h-fit max-h-80 lg:sticky lg:top-20 lg:max-h-[calc(100vh-6rem)] overflow-y-auto" data-testid="specialty-tree">
      <Row label="Tous les praticiens" count={total} active={!sel.cat} onClick={() => onSelect({})} testId="cat-all" />
      <label className="flex items-center gap-2 px-3 py-2 text-xs text-stone-600"><Switch checked={hideEmpty} onCheckedChange={setHideEmpty} data-testid="hide-empty-switch" /> Masquer les spécialités vides</label>
      {cats.map((c) => <Category key={c.name} cat={c} sel={sel} onSelect={onSelect} hideEmpty={hideEmpty} />)}
    </aside>
  );
};
